import React, { ReactNode } from "react";
import SubscriptionCard from "./components/SubscriptionCard";
import Hero from "../../components/Hero";
import MainButton from "../../components/buttons/MainButton";
const urlParams = new URLSearchParams(window.location.search);
const status = urlParams.get("status");
const plan = urlParams.get("plan");

const PaymentSuccess = () => {
 

  return (
    <>
      <section className="success-message-page">
        <div className={"container"}>
          <div className={"mb-5 mt-5"}>
            {/* <Hero text={`Payment ${status}`} /> */}
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 text-center">
                <h1 className="success-head mb-5">
                  {status === "success"
                    ? `You have successfully purchased the subscription plan (${plan})`
                    : "unfortunately your payment was cancelled please choose your plan again"}
                </h1>
                <MainButton
                  href={"/"}
                  text={"Back to Home"}
                  className={`btn btn-primary-dark ps-lg-5 pe-lg-5 ps-3 pe-3 `}
                  withLogo={true}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentSuccess;
